import { Box, styled } from '@mui/material';

export const EntityAvailabilityDialogContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '400px',
  gap: theme.spacing(4)
}));
